import { createContext } from 'react'
import type { AgentV2UIState } from '@/agent-v2/store/schemas'

export const AgentV2UIStateContext = createContext<AgentV2UIState | undefined>(undefined)
